(()=>{
  if(window.__jovelaOfferClockSync)return;
  window.__jovelaOfferClockSync=true;
  let observer;
  let source;
  const refresh=()=>{
    const value=source?.textContent?.trim() || '';
    const visible=/^\d{2}:\d{2}:\d{2}$/.test(value);
    document.querySelectorAll('[data-ha-clock-clone]').forEach(box=>{
      box.hidden=!visible;
      if(visible)box.querySelector('[data-ha-clock-value]').textContent=value;
    });
  };
  const connect=()=>{
    const next=document.querySelector('.ha-topbar__timer[data-ha-timer]');
    if(next!==source){
      observer?.disconnect();
      source=next;
      if(source){
        observer=new MutationObserver(refresh);
        observer.observe(source,{childList:true,characterData:true,subtree:true});
      }
    }
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',connect,{once:true});else connect();
  document.addEventListener('shopify:section:load',connect);
  document.addEventListener('shopify:section:unload',()=>setTimeout(connect,0));
})();
